<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  <form class="formAccount" #f="ngForm">
    <div class="container-fluid">
      <div class="row" *ngFor="let item of data.fields">
        <div class="col-md-4 col-sm-12 text-right field-label no-padding">
          <label *ngIf="isYear(item.id)" [translate]="'painel-dashboard/year'"></label>
          <label *ngIf="isObservation(item.id)" [translate]="'painel-dashboard/observation'"></label>
          <label *ngIf="isDataSource(item.id)" [translate]="'painel-dashboard/data-source'"></label>
          <label *ngIf="isValue(item.id)" [translate]="'painel-dashboard/value'"></label>
        </div>

        <div class="col-md-5 col-sm-8">
          <!-- ANO -->
          <mat-form-field class="form-full-width" *ngIf="isYear(item.id)">
            <input matInput type="tel" name="year" [(ngModel)]="item.value" [textMask]="{mask: yearMask, guide: false}" #year="ngModel" pastYear [disabled]="loading" required>
            <mat-icon *ngIf="year.errors && year.touched" class="mat-error" matSuffix>error</mat-icon>
            <mat-error>
              <span *ngIf="year.errors?.required" [translate]="'painel-dashboard/field-required'">Field Required</span>
              <span *ngIf="year.errors?.pastYear" [translate]="'painel-dashboard/invalid-year'"></span>
            </mat-error>
          </mat-form-field>

          <!-- DATA SOURCE -->
          <mat-form-field class="form-full-width" *ngIf="isDataSource(item.id)">
            <input matInput type="text" name="dataSource" [matAutocomplete]="auto" [(ngModel)]="item.value" #dataSource="ngModel" [disabled]="loading" required>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of item.option | filterReference:item.value" [value]="option.name">
                <span>{{option.name}}</span>
              </mat-option>
            </mat-autocomplete>

            <mat-icon *ngIf="dataSource.errors && dataSource.touched" class="mat-error" matSuffix>error</mat-icon>
            <mat-error>
              <span *ngIf="dataSource.errors?.required" [translate]="'painel-dashboard/field-required'">Field Required</span>
            </mat-error>
          </mat-form-field>

          <!-- VALUE -->
          <mat-form-field class="form-full-width" *ngIf="isValue(item.id)">            
            <input *ngIf="item.validation != 'ZERO_ONE'" matInput type="tel" name="value" [(ngModel)]="item.value" inputMask inputMaskType="{{item.validation}}" #value="ngModel" validatePercentage="{{item.validation}}" [disabled]="loading" required>
            <ng-container *ngIf="item.validation == 'ZERO_ONE'">
              <mat-select matInput type="tel" name="value" [(ngModel)]="item.value" inputMask inputMaskType="{{item.validation}}" #value="ngModel" validatePercentage="{{item.validation}}" [disabled]="loading" required>
                <mat-option [value]="1" [selected]="item.value == 1"><span translate>Sim</span></mat-option>
                <mat-option [value]="0" [selected]="item.value == 0 || (item.value == '' || item.value == null)"><span translate>Não</span></mat-option>
              </mat-select>
            </ng-container>
  
            <mat-icon *ngIf="item.validation != 'ZERO_ONE' && value?.errors && value?.touched" class="mat-error" matSuffix>error</mat-icon>

            <mat-error>
              <span *ngIf="item.validation != 'ZERO_ONE' && value?.errors?.required" [translate]="'painel-dashboard/field-required'">Field Required</span>
              <span *ngIf="item.validation != 'ZERO_ONE' && !value?.errors?.required && value?.errors?.percentage" translate>validation-error/{{item.validation}}</span>
              <span *ngIf="item.validation != 'ZERO_ONE' && !value?.errors?.required && !value?.errors?.percentage && value?.errors" [translate]="'painel-dashboard/invalid-value'">This value is not valid</span>
            </mat-error>
          </mat-form-field>

          <!-- OBSERVATION -->
          <mat-form-field class="form-full-width" *ngIf="isObservation(item.id)">
            <input matInput type="text" name="observation" [(ngModel)]="item.value" #observation="ngModel" [disabled]="loading">
          </mat-form-field>
        </div>

        <div class="col-md-3 col-sm-4 field-unity no-padding">
          <small>{{item.unity}}</small>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <app-loading-bar *ngIf="loading"></app-loading-bar>
  <p *ngIf="loading" [translate]="'painel-dashboard/wait'">Wait a moment</p>

  <button *ngIf="!loading" type="button" class="btn-painel clear" (click)="onNoClick($event)" [translate]="'painel-dashboard/cancel'">Cancel</button>
  <button *ngIf="!loading" class="btn-painel branded" (click)="f.form.valid && onSubmit()" [translate]="'painel-dashboard/save'" [disabled]="data.processing">Save</button>
  <button *ngIf="!loading && isDeletable()" class="btn-painel outline" (click)="onDelete()" [disabled]="data.processing">
    <i class="material-icons">delete</i>
    <span class="text-uppercase" [translate]="'painel-dashboard/delete'">Delete</span>
  </button>
</div>